<template>
    <badge :type="params.value" />
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({});
</script>
